import { TableCell } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
// import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import DeleteIcon from "@material-ui/icons/Delete";
import { ComboById_comboById } from "@saleor/combos/types/ComboById";
import CardTitle from "@saleor/components/CardTitle";
import Checkbox from "@saleor/components/Checkbox";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import {
  SortableTableBody,
  SortableTableRow
} from "@saleor/components/SortableTable";
import StatusLabel from "@saleor/components/StatusLabel";
import TableCellAvatar from "@saleor/components/TableCellAvatar";
import TableHead from "@saleor/components/TableHead";
// import TablePagination from "@saleor/components/TablePagination";
import { FormChange } from "@saleor/hooks/useForm";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { maybe, renderCollection } from "../../../misc";
import { ListActions, ListProps, ReorderAction } from "../../../types";
export interface ComboProductsPoprs extends ListProps, ListActions {
  combo: ComboById_comboById;
  onProductAssign: () => void;
  onProductUnassign: (id: string) => void;
  onChange: FormChange;
  onProductReorder: ReorderAction;
}

const useStyles = makeStyles(
  theme => ({
    colActions: {
      "&:last-child": {
        paddingRight: 0
      },
      width: 70 + theme.spacing(0.5)
    },
    colName: {
      padding: 0,
      width: 160
    },
    colNameText: {
      width: 100,
      overflow: "hidden", // 超出的文本隐藏
      textOverflow: "ellipsis", // 溢出用省略号显示
      whiteSpace: "nowrap" // 溢出不换行
    },
    colGrab: {
      width: 50
    },
    colPublished: {
      width: 150
    },
    colType: {
      width: 150
    },
    colPrice: {
      width: 100
    },
    colNum: {
      width: 200
    },
    table: {
      tableLayout: "fixed"
    },
    tableRow: {
      cursor: "pointer"
    }
  }),
  { name: "ComboProducts" }
);

const ComboProducts: React.FC<ComboProductsPoprs> = props => {
  const {
    combo,
    disabled,
    // pageInfo,
    onRowClick,
    // onPreviousPage,
    onProductAssign,
    onProductUnassign,
    // onNextPage,
    isChecked,
    selected,
    toggle,
    toggleAll,
    toolbar,
    onProductReorder
  } = props;
  const classes = useStyles(props);
  const numberOfColumns = 7;

  const intl = useIntl();

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Eligible Product",
          description: "section header"
        })}
        toolbar={
          <Button color="primary" onClick={onProductAssign}>
            <FormattedMessage
              defaultMessage="Assign Product"
              description="button"
            />
          </Button>
        }
      />
      <ResponsiveTable>
        <colgroup>
          <col className={classes.colGrab} />
          <col />
          <col className={classes.colName} />
          <col className={classes.colType} />
          <col className={classes.colPrice} />
          <col className={classes.colPrice} />
          <col className={classes.colPublished} />
          <col className={classes.colActions} />
        </colgroup>
        <TableHead
          colSpan={numberOfColumns}
          selected={selected}
          disabled={disabled}
          items={maybe(() => combo.comboProducts)}
          toggleAll={toggleAll}
          toolbar={toolbar}
          dragRows
        >
          <TableCell className={classes.colName}>
            <FormattedMessage defaultMessage="Product Name" />
          </TableCell>

          <TableCell className={classes.colType}>
            <FormattedMessage defaultMessage="Type Name" />
          </TableCell>
          <TableCell className={classes.colPrice}>
            <FormattedMessage defaultMessage="Price" />
          </TableCell>
          <TableCell className={classes.colPrice}>
            <FormattedMessage defaultMessage="Discount Price" />
          </TableCell>
          <TableCell className={classes.colPublished}>
            <FormattedMessage
              defaultMessage="Published"
              description="product is published"
            />
          </TableCell>
          <TableCell className={classes.colActions} />
        </TableHead>
        <SortableTableBody onSortEnd={onProductReorder}>
          {renderCollection(
            maybe(() => combo?.comboProducts),
            (product, index) => {
              if (!product) {
                return undefined;
              }
              const isSelected = product
                ? isChecked(product.product.id)
                : false;
              return (
                <SortableTableRow
                  className={classes.tableRow}
                  index={index || 0}
                  hover={!!product}
                  key={product ? product.id : "skeleton"}
                  selected={isSelected}
                >
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={isSelected}
                      disabled={disabled}
                      disableClickPropagation
                      onChange={() => toggle(product.product.id)}
                    />
                  </TableCell>
                  <TableCellAvatar
                    className={classes.colName}
                    thumbnail={maybe(() => product.product.thumbnail.url)}
                    onClick={product && onRowClick(product.product.id)}
                  >
                    {maybe<React.ReactNode>(
                      () => (
                        <p className={classes.colNameText}>
                          {product.product.name}
                        </p>
                      ),
                      <Skeleton />
                    )}
                  </TableCellAvatar>
                  <TableCell className={classes.colType}>
                    {maybe<React.ReactNode>(
                      () => product.product.productType.name,
                      <Skeleton />
                    )}
                  </TableCell>
                  <>
                    <TableCell className={classes.colPrice}>
                      {maybe<React.ReactNode>(
                        () => product?.product?.defaultVariant?.price?.amount,
                        <Skeleton />
                      )}
                    </TableCell>
                  </>
                  <>
                    <TableCell className={classes.colPrice}>
                      {maybe<React.ReactNode>(
                        () => product.discountPrice,
                        <Skeleton />
                      )}
                    </TableCell>
                  </>
                  <TableCell className={classes.colPublished}>
                    {product && product.product.isPublished !== undefined ? (
                      <StatusLabel
                        label={
                          product.product.isPublished
                            ? intl.formatMessage({
                                defaultMessage: "Published",
                                description: "product is published"
                              })
                            : intl.formatMessage({
                                defaultMessage: "Not published",
                                description: "product is not published"
                              })
                        }
                        status={
                          product.product.isPublished ? "success" : "error"
                        }
                      />
                    ) : (
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell className={classes.colActions}>
                    <IconButton
                      disabled={!product || disabled}
                      onClick={event => {
                        event.stopPropagation();
                        onProductUnassign(product.product.id);
                      }}
                    >
                      <DeleteIcon color="primary" />
                    </IconButton>
                  </TableCell>
                </SortableTableRow>
              );
            },
            () => (
              <TableRow>
                <TableCell colSpan={numberOfColumns}>
                  <FormattedMessage defaultMessage="No products found" />
                </TableCell>
              </TableRow>
            )
          )}
        </SortableTableBody>
      </ResponsiveTable>
    </Card>
  );
};
ComboProducts.displayName = "ComboProducts";
export default ComboProducts;
